export default __webpack_public_path__ + "../staticImages/advent-lightbox-top-2x.png";